import { Formik, FormikHelpers, FormikProps } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col } from 'react-bootstrap';
import Store from '../../store';
import { emptyAppointmentType } from '../../store/initial';
import { InjectedProps } from '../../types';
import { AppointmentTypes } from '../../types/AppointmentType';
import ControlButtonSave from '../misc/ControlButtonSave';
import AppointmentTypeForm, { IAppointmentType } from './AppointmentTypeForm';

interface AppointmentTypeNewProps {
    handleClose: (appointmentTypes: AppointmentTypes) => any;
    store?: Store;
}

@inject('store')
@observer
export class AppointmentTypeNew extends React.Component<AppointmentTypeNewProps> {
    public get injected() {
        return this.props as InjectedProps;
    }

    public initialValues = () => ({ ...emptyAppointmentType });

    public render() {
        return (
            <>
                <Col>
                    <Formik
                        initialValues={this.initialValues()}
                        enableReinitialize
                        onSubmit={this.handleSubmit}
                    >{this.renderForm()}</Formik>
                </Col>
            </>
        );
    }

    public renderForm = () => {
        return AppointmentTypeForm({
            editing: true,
            controls: (bag: FormikProps<IAppointmentType>) => <ControlButtonSave />
        });
    };

    public handleSubmit = (values: any, actions: FormikHelpers<any>) => {
        actions.setSubmitting(true);
        const { appointmentTypes } = this.injected.store;
        const { handleClose } = this.props;
        actions.setSubmitting(false);
        return appointmentTypes.create(values)
            .then(() => {
                actions.resetForm();
                handleClose(values);
            })
            .catch(error => actions.setErrors(error.response.data));
    };
}

export default AppointmentTypeNew;
